import React, { Fragment } from "react";
import styled from "styled-components";
import { Centered } from "../../containers/Layout";
import FooterSegment from "../../segments/FooterSegment";
import { SiteData } from "react-static";
import { ResponsiveImage } from "../../containers/ProgressiveHelpers";

const Organization = styled.div`
  margin: 5em 0 5em 0;
  box-sizing: border-box;
  display: inline-flex;
  flex-direction: column;
  font-family: Raleway, sans-serif;
  font-weight: 400;
  color: #333333;
  justify-self: center;
  align-items: center;
`;

const Container = styled.div`
  width: 25em;
`;

const Image = styled.img`
  max-width: 100%;
  height: auto;
  object-fit: scale-down;
`;

const Content = styled.div`
  font-size: 1.5em;
  padding: 1em;
  text-align: center;
`;

export default () => (
  <SiteData
    render={({ cms }) => (
      <Fragment>
        <Centered>
          <Organization>
            <Content children={cms["footer-section"]["association-title"]} />
            <Container>
              <ResponsiveImage
                path={cms["footer-section"]["association-logo-image"]}
              >
                <Image />
              </ResponsiveImage>
            </Container>
          </Organization>
        </Centered>
        <FooterSegment />
      </Fragment>
    )}
  />
);



// WEBPACK FOOTER //
// /opt/build/repo/src/pages/Landing/FooterSection.js